import React, { useState } from 'react'
import { Box, Dialog } from '@material-ui/core'

import {
  EmailTopBar,
  EmailView,
  EmailFooter,
  FakePageView,
  PhishingWarning,
} from './components'
import useStyles from './styles'

const PreviewModal = ({ open, onClose, template, onBack, onSendTest }) => {
  const classes = useStyles()
  const [currentPage, setCurrentPage] = useState(1)

  if (!template) return null

  const fakePages = Array.isArray(template.fakePageHtml)
    ? template.fakePageHtml
    : []
  const totalPages = 1 + fakePages.length + 1

  const handleNext = () =>
    setCurrentPage((previous) => Math.min(previous + 1, totalPages))
  const handlePrev = () =>
    setCurrentPage((previous) => Math.max(previous - 1, 1))

  const handleClose = () => {
    setCurrentPage(1)
    onClose()
  }

  const handleBack = () => {
    if (currentPage > 1) {
      setCurrentPage(1)
    } else if (onBack) {
      onBack()
    }
  }

  const renderBody = () => {
    if (currentPage === 1) return <EmailView template={template} />
    if (currentPage === totalPages) return <PhishingWarning />
    const fakePage = fakePages[currentPage - 2]
    return <FakePageView html={fakePage?.html} />
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      PaperProps={{ className: classes.dialogPaper }}
    >
      <Box className={classes.root}>
        <EmailTopBar title="Pré visualização de modelo de phishing" />

        <Box className={classes.body}>{renderBody()}</Box>

        <EmailFooter
          onBack={handleBack}
          onSendTest={() => onSendTest(template)}
          currentPage={currentPage}
          totalPages={totalPages}
          onNext={handleNext}
          onPrev={handlePrev}
        />
      </Box>
    </Dialog>
  )
}

export default PreviewModal
